"use strict";
(function(global) {
    class FeedPreviewController {
        constructor(config) {
            this.init(config);
        }

        init(config) {
            this.createGrid(config);
        }

        createGridIPDNS(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Czas zdarzenia",
                    "dataIndex": "event_time",
                    "dataType": "text",
                    "isEditable": false
                }, {
                    "label": "IP Malware'u",
                    "dataIndex": "malware_ip",
                    "dataType": "text",
                    "isEditable": false,
                    "width": "*"
                }, {
                    "label": "DNS Malware'u",
                    "dataIndex": "malware_dns",
                    "dataType": "text",
                    "isEditable": false

                }, {
                    "label": "Nazwa Malware'u",
                    "dataIndex": "malware_name",
                    "dataType": "text",
                    "isEditable": false
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_ip_dns_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId1"
            });

            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container-ip-dns',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "showAllRows": config.show_all_rows || false,
                "pageSize": (config.show_all_rows) ? 99999999 : 20,
                'listeners': {}
            });
        }

        createGridWebGatewayDNS(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Czas zdarzenia",
                    "dataIndex": "event_time",
                    "dataType": "text",
                    "isEditable": false
                }, {
                    "label": "IP Malware'u",
                    "dataIndex": "malware_ip",
                    "dataType": "text",
                    "isEditable": false,
                    "width": "*"
                }, {
                    "label": "DNS Malware'u",
                    "dataIndex": "malware_dns",
                    "dataType": "text",
                    "isEditable": false

                }, {
                    "label": "Nazwa Malware'u",
                    "dataIndex": "malware_name",
                    "dataType": "text",
                    "isEditable": false
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_web_gateway_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId2"
            });

            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container-web-gateway',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "pageSize": 20,
                'listeners': {}
            });
        }

        createGridHoneypot(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Czas zdarzenia",
                    "dataIndex": "event_time",
                    "dataType": "text",
                    "isEditable": false
                }, {
                    "label": "Państwo",
                    "dataIndex": "country",
                    "dataType": "text",
                    "isEditable": false,
                    "width": "*"
                }, {
                    "label": "Źródłowy IP",
                    "dataIndex": "source_ip",
                    "dataType": "text",
                    "isEditable": false

                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_honeypot_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId3"
            });

            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container-honeypot',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "pageSize": 20,
                'listeners': {
                }
            });
        }

        createGrid(config) {
            this.createGridIPDNS(config);
            this.createGridWebGatewayDNS(config);
            this.createGridHoneypot(config);
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.FeedPreviewController = FeedPreviewController || {};

})(window);
